import Box from '@mui/material/Box';
import React from 'react';
import PropTypes from 'prop-types';
import { CalendarImage, HistoryImage } from '../../../assets/Images';

const titleStyle = {
  fontSize: '19px',
  lineHeight: '25px',
  fontWeight: '700',
  color: '#054E8B',
  fontFamily: 'Mukta',
};
const descStyle = {
  fontSize: '15px',
  lineHeight: '19px',
  fontWeight: '400',
  color: '#2A3752',
  fontFamily: 'Mulish',
};
const EmptyStatesForTab = (props) => {
  return (
    <Box
      sx={{
        height: 'calc(100vh - 210px)',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Box style={titleStyle}>
        {props.title === 'No Order History Yet' ? (
          <img src={HistoryImage} alt="" style={{ width: '3.37em' }} />
        ) : (
          <img src={CalendarImage} alt="" style={{ width: '3.37em' }} />
        )}
      </Box>
      <Box style={titleStyle}>{props.title}</Box>
      <Box style={descStyle}>{props.description}</Box>
    </Box>
  );
};
EmptyStatesForTab.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
};
export default EmptyStatesForTab;
